import { useMemo } from 'react';
import { SegmentedToggle } from './SegmentedToggle';
import { FieldLabel } from './VirtualAppointmentFieldParts';
import { openNowModeOptions, type OpenNowMode } from './openNowMode';
import { OPEN_NOW_TREATMENT_ONLY_HINT } from './openNowScope';

interface OpenNowModeFieldProps {
    value: OpenNowMode;
    canOpenNow: boolean;
    onChange: (mode: OpenNowMode) => void;
}

export function OpenNowModeField({ value, canOpenNow, onChange }: OpenNowModeFieldProps) {
    const options = useMemo(() => openNowModeOptions(canOpenNow), [canOpenNow]);
    return (
        <div className="flex-shrink-0 flex flex-col">
            <FieldLabel>When</FieldLabel>
            <div className="w-full max-w-[240px]">
                <SegmentedToggle
                    value={value}
                    options={options}
                    onChange={onChange}
                    ariaLabel="When the VA opens"
                />
            </div>
            {!canOpenNow && (
                <p className="mt-1 break-words text-xs text-gray-500">
                    {OPEN_NOW_TREATMENT_ONLY_HINT}
                </p>
            )}
        </div>
    );
}
